module.exports = __webpack_public_path__ + "img/slide-39.cec05ba4.jpeg";